/**
 * One dashboard KPI tile. Extracted from the original monolithic Dashboard.jsx
 * so the three role dashboards share one implementation.
 *
 * `value` is a count. This component deliberately has no money formatting:
 * dollar values do not belong in the top row of any dashboard (dealer
 * feedback, September showcase), and keeping the capability out of the tile
 * is how that stays true.
 */

import { useNavigate } from 'react-router-dom';
import { Sparkline } from '../Charts';

export default function KpiTile({
  label,
  value,
  sub,
  color = 'var(--accent-primary)',
  tone,               // 'danger' | 'warning' | 'success' — colours the sub line
  spark,              // optional number[]
  periodLabel,        // optional, shown top-right ("Today", "7d")
  to,                 // optional route
  tooltip,
  index = 0,          // for the staggered animate-in
  onClick,
}) {
  const navigate = useNavigate();
  const go = onClick || (to ? () => navigate(to) : undefined);
  const Tag = go ? 'button' : 'div';

  return (
    <Tag
      className="kpi-tile animate-in"
      style={{ animationDelay: `${index * 0.05}s`, '--kpi-accent': color, cursor: go ? 'pointer' : 'default' }}
      onClick={go}
      title={tooltip}
      type={go ? 'button' : undefined}
    >
      <div className="kpi-head">
        <span className="card-label">{label}</span>
        {periodLabel && <span className="kpi-period mono text-xs text-muted">{periodLabel}</span>}
      </div>
      <div className="metric-value" style={{ color }}>{value ?? '—'}</div>
      {sub && <div className={`metric-sub ${tone || ''}`}>{sub}</div>}
      {Array.isArray(spark) && spark.length > 1 && (
        <div className="kpi-spark">
          <Sparkline values={spark} w={180} h={32} color={color} />
        </div>
      )}
      {tooltip && <div className="kpi-tooltip">{tooltip}</div>}
    </Tag>
  );
}
